import 'destyle.css';
import "@elsa-zku/lib/styles/_fontFaceManrope.scss";
import "src/style/_vars.scss";
import './style.scss';
import "@elsa-zku/lib/helpers/browserLocalStorage";
import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";

const root = createRoot(document.getElementById('app'));
root.render(<App />);
